var StandoffSpacerData = require('./standoffSpacerData.js');
var lib_core = require("lib-core");
var PthComponentAttribute = require('./pthComponentAttribute.js');

var FemaleStandoffSpacerData = function(position, angle, init) {
    var self = this;
    StandoffSpacerData.apply(this, arguments);

    this.hasThread = this.value("hasThread", true);
    this.hasPartialThread = this.value("hasPartialThread", true);
    this.threadType = this.value("threadType", true);
    this.threadSize = this.value("threadSize", true);
    this.threadDesignation = this.value("threadDesignation", true);
    this.threadDepth = this.value("threadDepth", true); // used if thread is partial

    this.nonTransformedSegmentedGeometry.addTrigger(this.hasThread);
    this.nonTransformedSegmentedGeometry.addTrigger(this.hasPartialThread);
    this.nonTransformedSegmentedGeometry.addTrigger(this.threadType);
    this.nonTransformedSegmentedGeometry.addTrigger(this.threadSize);
    this.nonTransformedSegmentedGeometry.addTrigger(this.threadDesignation);
    this.nonTransformedSegmentedGeometry.addTrigger(this.threadDepth);

    this.gender(PthComponentAttribute.type.ELECTRO_MECHANICAL.types.STANDOFF_SPACER.genders.FEMALE);
    this.threadType(PthComponentAttribute.threadTypes.ISO_METRIC.name);

    this.hasThread.onChange(this, function(val) {
        if (!val) {
            self.hasPartialThread(false);
        }
    });
};

lib_core.inherit(FemaleStandoffSpacerData, StandoffSpacerData);
lib_core.JsonParser.registerClass(FemaleStandoffSpacerData, "FemaleStandoffSpacerData");

module.exports = FemaleStandoffSpacerData;